import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useCurrentCategory } from '@/hooks/useCurrentCategory/useCurrentCategory';
import { getCategoryPath } from '@/utils/helpers';
import { useAdDetails } from '@/views/Ads/useAdDetails';

export function useCategoryPathSynchronizer() {
  const router = useRouter();
  const { currentCategory } = useCurrentCategory();
  const { adDetails } = useAdDetails();

  function synchronizePath() {
    const categoryPath = adDetails
      ? getCategoryPath(adDetails.path)
      : currentCategory?.path;
    const currentCategoryPath = getCategoryPath(router.asPath);

    if (
      categoryPath &&
      currentCategoryPath &&
      categoryPath !== currentCategoryPath
    ) {
      const newPath = router.asPath.replace(currentCategoryPath, categoryPath);
      router.replace(newPath);
    }
  }

  useEffect(() => {
    synchronizePath();
  }, [adDetails?.path, currentCategory?.path]);
}
